export default {
    "Overview": "Übersicht",
    "Energy": "Energie",
    "KPI": "KPI",
    "Notification Breakdown": "Benachrichtigungsaufschlüsselung",
    "Notification Summary": "Benachrichtigungszusammenfassung",
    "Monthly Summary": "Monatliche Zusammenfassung",
    "Plots": "Diagramme",
    "Time Series Plots": "Zeitreihen-Diagramme",
    "Equipment Plots": "Anlagendiagramme",
    "Facet Plots": "Facettendiagramme",
    "Scatter Plots": "Streudiagramme",
    "Fault Detection": "Fehlererkennung",
    "Fault Detection (Machine Learning)": "Fehlererkennung (Maschinelles Lernen)",
    "Fault Summary": "Fehlerzusammenfassung",
    "Diagnostics": "Diagnose",
    "Cooling Load": "Kühllast",
    "CHW Supply Temperature": "CHW-Vorlauftemperatur",
    "CHW Return Temperature": "CHW-Rücklauftemperatur",
    "Chiller Performance": "Kältemaschinenleistung",
    "Cooling Performance": "Kühlleistung",
    "Working Hours": "Betriebsstunden",
    "Chiller Overview": "Kältemaschinenübersicht",
    "Config": "Konfiguration",
    "Equipments": "Ausrüstungen",
    "Facilities": "Anlagen",
    "Anomaly Descriptions": "Anomaliebeschreibungen",
    "Points": "Messpunkte",
    "Parameter": "Parameter",
    "Settings": "Einstellungen",
    "Report": "Bericht",
    "Rules": "Regeln",
    "Export Data": "Daten exportieren",
    "Custom Views": "Benutzerdefinierte Ansichten",
    "Dates": "Daten",
    "Equipment Servicing Schedule": "Wartungsplan für Ausrüstung",
    "Menu items": "Menüelemente",
    "Maintenance Record": "Wartungsprotokoll",
    "Terms of Service": "Nutzungsbedingungen",
    "Logged in as": "Angemeldet als",
    "Account Settings": "Kontoeinstellungen",
    "Logout": "Abmelden",
    "Loading Points List": "Lade Punkteliste",
    "Save": "Speichern",
    "Cancel": "Abbrechen",
    "User Name": "Benutzername",
    "Email": "E-Mail-Adresse",
    "Change password?": "Passwort ändern?",
    "Issue": "Problem",
    "Equipment": "Ausrüstung",
    "Equipment Type": "Ausrüstungstyp",
    "Floor": "Etage",
    "Start Date": "Startdatum",
    "End Date": "Enddatum",
    "ID": "ID",
    "Actions": "Aktionen",
    "Energy Consumption VS Baseline": "Energieverbrauch vs. Basislinie",
    "Not including all equipment in the building": "Nicht alle Geräte im Gebäude eingeschlossen",
    "Hour": "Stunde",
    "Fault severity": "Fehler-Schweregrad",
    "Fault breakdown": "Fehleraufschlüsselung",
    "Room Temperature": "Raumtemperatur",
    "AHU Run Time (hr)": "AHU-Betriebszeit (Std.)",
    "Chiller Run Time (hr)": "Kältemaschinen-Betriebszeit (Std.)",
    "User": "Benutzer",
    "test": "Test",
    "Chillers": "Kältemaschinen",
    "Pumps": "Pumpen",
    "VAVs": "VAV-Systeme (variable Luftvolumen)",
    "AHUs": "AHU (Luftbehandlungsgeräte)",
    "Cooling Towers": "Kühltürme",
    "Baseline": "Basislinie",
    "Power (Chiller only) ": "Leistung (nur Kältemaschine)",
    "Time": "Zeit",
    "Power Consumption": "Leistungsaufnahme",
    "Energy Consumption Profile": "Energieverbrauchsprofil",
    "Time (hourly)": "Zeit (stündlich)",
    "Energy Consumption Breakdown": "Energieverbrauchsaufschlüsselung",
    "Air conditioning - Air side": "Klimaanlage – Luftseite",
    "Power Heat Map": "Leistungs-Heatmap",
    "Chiller": "Kältemaschine",
    "Chiller COP": "Kältemaschinen-COP",
    "AHU": "AHU",
    "Annualized BPI": "Jährlicher BPI (Gebäudeleistungsindex)",
    "Occupant Comfort Index": "Raumkomfortindex",
    "Maintenance Fault Index": "Wartungs-Fehler-Index",
    "Energy Saving": "Energieersparnis",
    "Severity": "Schweregrad",
    "Modify Logic and Severity": "Logik und Schweregrad ändern",
    "Mark as Useful": "Als nützlich markieren",
    "Topic": "Thema",
    "Download": "Herunterladen",
    "Alerts": "Warnmeldungen",
    "Recommended Actions": "Empfohlene Maßnahmen",
    "Acknowledged": "Bestätigt",
    "Acknowledged by": "Bestätigt von",
    "Last acknowledged date": "Letztes Bestätigungsdatum",
    "Acknowledge": "Bestätigen",
    "Un-Acknowledge": "Bestätigung aufheben",
    "Occured between": "Aufgetreten zwischen",
    "and": "und",
    "Add Maintenance Record": "Wartungsprotokoll hinzufügen",
    "View Chart": "Diagramm anzeigen",
    "View Chart in New Tab": "Diagramm in neuem Tab anzeigen",
    "Add maintenance record": "Wartungsprotokoll hinzufügen",
    "View chart": "Diagramm anzeigen",
    "View maintenanace records for this period": "Wartungsprotokolle für diesen Zeitraum anzeigen",
    "Equipment Health Score": "Zustandskennzahl der Ausrüstung",
    "Export as PDF": "Als PDF exportieren",
    "Create Maintenance Record": "Wartungsprotokoll erstellen",
    "Create maintenance record": "Wartungsprotokoll erstellen",
    "Maintenance Records": "Wartungsprotokolle",
    "Show All Maintenance Records": "Alle Wartungsprotokolle anzeigen",
    "Jump to Equipment Trend Plots": "Zu Anlagentrends-Diagrammen springen",
    "Supervised Detection": "Überwachte Erkennung",
    "Algorithm Detection": "Algorithmische Erkennung",
    "Health": "Zustand",
    "Sensor": "Sensor",
    "Supervised Detection Scores (Higher indicates error)": "Überwachte Erkennungspunkte (höhere Werte zeigen Fehler an)",
    "Anomaly Detection Scores (Higher indicates error)": "Anomalieerkennungspunkte (höhere Werte zeigen Fehler an)",
    "Unack": "Nicht bestätigt",
    "Medium": "Mittel",
    "High": "Hoch",
    "30 days": "30 Tage",
    "90 days": "90 Tage",
    "1 year": "1 Jahr",
    "all": "alle",
    "Keyword filter": "Stichwortfilter",
    "Critical/High/Medium": "Kritisch/Hoch/Mittel",
    "Low": "Niedrig",
    "Anomaly": "Anomalie",
    "Relevant variables": "Relevante Variablen",
    "Fault Analysis": "Fehleranalyse",
    "Export all as PDF": "Alles als PDF exportieren",
    "Rule evaluation": "Regelauswertung",
    "Change": "Ändern",
    "Analysis": "Analyse",
    "Energy Consumption Comparison Summary": "Zusammenfassung des Energieverbrauchsvergleichs",
    "Outdoor Temperature": "Außentemperatur",
    "Fault Severity": "Fehler-Schweregrad",
    "Chiller Running Hours": "Betriebsstunden der Kältemaschine",
    "Fault Breakdown": "Fehleraufschlüsselung",
    "Weather": "Wetter",
    "Baseline Weather": "Basis-Wetterdaten",
    "Print": "Drucken",
    "Energy/Faults": "Energie/Fehler",
    "Chiller Plant Performance": "Leistung der Kältemaschinenanlage",
    "Current": "Aktuell",
    "YTD this year": "Seit Jahresbeginn (dieses Jahr)",
    "YTD last year": "Seit Jahresbeginn (letztes Jahr)",
    "FDD Costs": "FDD-Kosten (Fehlerdiagnose)",
    "Unacknowledged": "Unbestätigt",
    "Total": "Gesamt",
    "Plant COP (chiller only)": "COP der Anlage (nur Kältemaschine)",
    "Time ": "Zeit ",
    "COP": "COP",
    "Chiller COP vs Cooling Load": "Kältemaschinen-COP vs. Kühllast",
    "Energy Consumption": "Energieverbrauch",
    "Plant COP (chiller only) vs Outdoor Temperature": "COP der Anlage (nur Kältemaschine) vs. Außentemperatur",
    "Header Main Supply Temperature vs Outdoor Temperature": "Haupt-Vorlauftemperatur vs. Außentemperatur",
    "Outdoor Temp": "Außentemp.",
    "Header Main Supply Temperature": "Hauptvorlauftemperatur",
    "Chilled Water Delta Temp": "Kaltwasser-Delta-Temperatur",
    "Temperature Diff": "Temperaturdifferenz",
    "Chiller Plant": "Kältemaschinenanlage",
    "Runtime": "Laufzeit",
    "Fault": "Fehler",
    "No fault detected from": "Kein Fehler erkannt von",
    "to": "bis",
    "View anomalies for": "Anomalien anzeigen für",
    "View notifications for": "Benachrichtigungen anzeigen für",
    "View equipment summary for": "Ausrüstungszusammenfassung anzeigen für",
    "FDD Faults": "FDD-Fehler",
    "Recommended actions": "Empfohlene Maßnahmen",
    "Most Expensive Faults. Total Cost": "Teuerste Fehler. Gesamtkosten",
    "Faults With Highest Duration Of Occurrence (hr)": "Fehler mit der längsten Auftretensdauer (Std.)",
    "Date From": "Datum von",
    "Date To": "Datum bis",
    "Fixed": "Behoben",
    "Assigned to": "Zugewiesen an",
    "Assigned by": "Zugewiesen durch",
    "Assigned date": "Zuweisungsdatum",
    "Assigned to me": "Mir zugewiesen",
    "Assigned by me": "Von mir zugewiesen",
    "View Points when Chiller is On": "Punkte anzeigen, wenn Kältemaschine läuft",
    "Latest Cooling Load Forecast": "Neueste Prognose der Kühllast",
    "Forecast": "Prognose",
    "Chiller Staging Profile": "Stufenprofil der Kältemaschine",
    "Export charts as PDF": "Diagramme als PDF exportieren",
    "PMV": "PMV (Predicted Mean Vote)",
    "View this rule on other equipments in": "Diese Regel auf anderen Geräten anzeigen in",
    "View faults for": "Fehler anzeigen für",
    "Date Range": "Datumsbereich",
    "Today": "Heute",
    "Yesterday": "Gestern",
    "Last 30 Days": "Letzte 30 Tage",
    "Fault Comparison": "Fehlervergleich",
    "Rule": "Regel",
    "No matching equipments": "Keine passenden Ausrüstungen",
    "No Fault detected for this range and equipment": "Kein Fehler für diesen Bereich und diese Ausrüstung erkannt",
    "No Relevant Notifications": "Keine relevanten Benachrichtigungen",
    "Equipment Name": "Ausrüstungsname",
    "Search": "Suchen",
    "Refresh": "Aktualisieren",
    "Active (hr)": "Aktiv (Std.)",
    "Cost": "Kosten",
    "Active (as % of on time)": "Aktiv (als % der Laufzeit)",
    "Last Detected": "Zuletzt erkannt",
    "Issues Diagnostics for": "Problemdiagnose für",
    "Other Readings": "Andere Messwerte",
    "Anomaly Machine Learning Models": "Maschinelle Lernmodelle für Anomalien",
    "Anomaly machine learning models establish normal operation profile using historical data.": "ML-Modelle zur Anomalieerkennung erstellen anhand historischer Daten ein Normalbetriebsprofil.",
    "Machine Learning model is data driven and can handle non-linear boundaries and high dimensionality.": "Das ML-Modell ist datengetrieben und kann nichtlineare Grenzen sowie hohe Dimensionalität verarbeiten.",
    "Show Mine Only": "Nur meine anzeigen",
    "Bulk Upload Excel": "Massen-Upload (Excel)",
    "Add Record": "Eintrag hinzufügen",
    "Notifications": "Benachrichtigungen",
    "Show Unack Notifications Only": "Nur unbestätigte Benachrichtigungen anzeigen",
    "Add Plots": "Diagramme hinzufügen",
    "Filter": "Filter",
    "Drag to Add Lines to Plot": "Ziehen, um Linien zum Diagramm hinzuzufügen",
    "Password": "Passwort",
    "Login": "Anmelden",
    "Set Server URL": "Server-URL festlegen",
    "Variable X": "Variable X",
    "Variable Y": "Variable Y",
    "Facet Groups": "Facettengruppen",
    "Variable Facet": "Variablen-Facette",
    "Chiller Optimisation Example": "Beispiel zur Optimierung einer Kältemaschine",
    "Using PSO optimisation algorithm, expected COP under different operating parameters at particular cooling loads can be found as depicted by the red dots.  The historical consumption is shown as blue dots below.  By choosing optimal temperature setpoints and sequencing, energy saving can be achieved by picking the set of parameters achieving highest COP.":
        "Mithilfe des PSO-Optimierungsalgorithmus kann ein erwarteter COP unter verschiedenen Betriebsparametern bei bestimmten Kühllasten ermittelt werden (rote Punkte). Der historische Verbrauch wird durch die blauen Punkte dargestellt. Durch Wahl optimaler Temperatureinstellungen und Schaltreihenfolgen lässt sich Energie einsparen, indem diejenigen Parameter ausgewählt werden, die den höchsten COP erzielen.",
    "95% Confidence Interval": "95-%-Konfidenzintervall",
    "Actual observed value": "Tatsächlich beobachteter Wert",
    "Fitted value": "Angepasster Wert",
    "Expected value": "Erwarteter Wert",
    "Upload File": "Datei hochladen",
    "Remove existing rules": "Vorhandene Regeln entfernen",
    "Upload": "Hochladen",
    "Upload Excel": "Excel hochladen",
    "Maintenance Records Creation": "Erstellung von Wartungsprotokollen",
    "Reference URL": "Referenz-URL",
    "Fixed?": "Behoben?",
    "Normal maintenance record": "Normales Wartungsprotokoll",
    "Comment": "Kommentar",
    "Add": "Hinzufügen",
    "View Reference Link": "Referenzlink anzeigen",
    "View Reference Link in New Tab": "Referenzlink in neuem Tab anzeigen",
    "Optimization Saving": "Optimierungsersparnis",
    "Digital Twins": "Digitale Zwillinge",
    "Chiller Efficiency Surface": "Effizienzoberfläche der Kältemaschine",
    "Optimization Saving Calculation": "Berechnung der Optimierungsersparnis",
    "Optimization is based on temperature reset of the chilled water supply temperature as well as optimal staging of chillers and pumps.":
        "Die Optimierung basiert auf der Neufestlegung der Kaltwasservorlauftemperatur sowie einem optimalen Stufenbetrieb von Kältemaschinen und Pumpen.",
    "Chillers' efficiency would also differ under different loading percentage, environmental conditions and external factors. This provides opportunity to improve the staging of chillers. Further optimization is possible due to unfulfilled temperature reset and differential pressure reset potential. Less cooling capacity buffer would be required if air-side sensors indicates that room temperature is optimal.":
        "Die Effizienz von Kältemaschinen variiert außerdem bei unterschiedlicher Last, unter verschiedenen Umweltbedingungen und externen Faktoren. Dies bietet eine Möglichkeit, die Stufenregelung der Kältemaschinen zu verbessern. Eine zusätzliche Optimierung ist möglich, wenn noch Potenzial für eine dynamische Temperatur- und Druckdifferenzregelung vorhanden ist. Ein geringerer Puffer der Kälteleistung wäre nötig, wenn Sensoren auf der Luftseite anzeigen, dass die Raumtemperatur optimal ist.",
    "Total Cooling Load": "Gesamte Kühllast",
    "Duration": "Dauer",
    "Projected Energy Consumption": "Prognostizierter Energieverbrauch",
    "Saving": "Ersparnis",
    "Cost Savings": "Kosteneinsparungen",
    "Diagnostic Plots": "Diagnosediagramme",
    "Power consumption forecast based on setpoint such as evaporator supply temperature and external environment factors such as condenser water temperature and outdoor air temperature.":
        "Leistungsverbrauchsprognose basierend auf Sollwerten (z. B. Verdampfer-Vorlauftemperatur) sowie externen Umgebungsfaktoren wie Kondensatorwassertemperatur und Außentemperatur.",
    "The charts reveal the relationship between the prediction and actual consumption.  A chart showing a strong correlation indicates a good model.":
        "Die Diagramme zeigen die Beziehung zwischen Prognose und tatsächlichem Verbrauch. Ein Diagramm mit einer hohen Korrelation deutet auf ein gutes Modell hin.",
    "Chiller efficiency is greatly influenced by the loading of the chiller and external factor such as condenser water temperature.":
        "Die Effizienz der Kältemaschine wird stark von der Last und externen Faktoren wie der Kondensatorwassertemperatur beeinflusst.",
    "The 3D scatter plots of the power consumption reveals a efficiency surface where chiller optimization can be performed.":
        "Die 3D-Streudiagramme des Leistungsverbrauchs zeigen eine Effizienzoberfläche, auf der eine Kältemaschinenoptimierung durchgeführt werden kann.",
    "Chilled Water Supply Temp (actual)": "Tatsächliche Kaltwasservorlauftemperatur",
    "Plant COP": "COP der Anlage",
    "Plant Power": "Anlagenleistung",
    "Chilled Water Supply Temp (optimized)": "Optimierte Kaltwasservorlauftemperatur",
    "Original COP": "Ursprünglicher COP",
    "Optimized COP": "Optimierter COP",
    "Original Power": "Ursprüngliche Leistung",
    "Optimized Power": "Optimierte Leistung",
    "Menu Configuration": "Menükonfiguration",
    "Air Side Equipment": "Luftseitige Ausrüstung",
    "Overall Power Status": "Gesamt-Leistungsstatus",
    "Condensing Water Pump": "Kondensatwasserpumpe",
    "Power Analyzer": "Leistungsanalysator",
    "Chilled Water Pump": "Kaltwasserpumpe",
    "Cooling Tower": "Kühlturm",
    "CHW Header": "CHW-Sammelleitung",
    "Heatmaps": "Heatmaps",
    "PAU Breakdown": "PAU-Aufschlüsselung (Außenluftanlage)",
    "PAU CD_Tem & VFD_Feedback": "PAU Zulufttemp. & VFD-Rückmeldung",
    "AHU CD_Tem & RT_Tem & VFD_Feedback": "AHU Zulufttemp. & Rücklufttemp. & VFD-Rückmeldung",
    "AHU CD_Tem & RT_Tem & Valve_Control": "AHU Zulufttemp. & Rücklufttemp. & Ventilsteuerung",
    "PAU CD_Tem & Valve_Control": "PAU Zulufttemp. & Ventilsteuerung",
    "AHU RT_Tem vs. VFD_Feedback": "AHU Rücklufttemp. vs. VFD-Rückmeldung",
    "PAU CD_Tem vs. Valve Control": "PAU Zulufttemp. vs. Ventilsteuerung",
    "AHU CD_Tem vs. Valve Control": "AHU Zulufttemp. vs. Ventilsteuerung",
    "AHU Breakdown": "AHU-Aufschlüsselung",
    "AHU CO2": "AHU CO₂",
    "PAU CO2": "PAU CO₂",
    "Environmental Performance": "Umweltleistung",
    "Running Status - CHWP & WCC": "Betriebsstatus – CHWP & WCC (Kaltwasserpumpe & wassergekühlter Kälter)",
    "Equipment Power Consumption": "Leistungsaufnahme der Ausrüstung",
    "Running Status - CHWP-A & ACC": "Betriebsstatus – CHWP-A & ACC (Kaltwasserpumpe-A & luftgekühlter Kühler)",
    "Running Status - WCC & CWP & CT": "Betriebsstatus – WCC & KWP & KT (wassergekühlter Kälter, Kühlwasserpumpe & Kühlturm)",
    "Running Status - AHU & PAU": "Betriebsstatus – AHU & PAU",
    "Running Status vs. Schedule": "Betriebsstatus vs. Zeitplan",
    "CDW Delta T vs Mean CDWP Power": "Delta T Kühlwasser vs. mittlere Leistung der Kühlwasserpumpe",
    "WCC Cond Entering & Leaving Temperature": "Ein- & Austrittstemperatur am Kondensator (wassergekühlter Kälter)",
    "WCC CHWR_Temp & CHWS_Temp": "CHW-Rück- & Vorlauftemperatur (wassergekühlter Kälter)",
    "WCC Cooling Load Overview": "Übersicht Kühllast (wassergekühlter Kälter)",
    "WCC COP": "COP des wassergekühlten Kälters",
    "COP vs Cooling Loads ": "COP vs. Kühllast",
    "POA Power Factor": "Leistungsfaktor (Power Analyzer)",
    "POA Hz": "Frequenz (Power Analyzer)",
    "POA Voltage": "Spannung (Power Analyzer)",
    "POA Power": "Leistung (Power Analyzer)",
    "CHWP VSD_Speed_Feedback": "VSD-Geschwindigkeitsrückmeldung der Kaltwasserpumpe",
    "CT Speed_Feedback": "Geschwindigkeitsrückmeldung Kühlturm",
    "CT Wetbulb Approach": "Kühlturm-Nasskugelansatz",
    "CT Breakdown": "Kühlturm-Aufschlüsselung",
    "CT Speed Feedback & Running Status": "Kühlturm-Geschwindigkeitsrückmeldung & Betriebsstatus",
    "CT Entering & Leaving Temperature": "Ein- & Austrittstemperatur Kühlturm",
    "AHU PAU Temperatures and Setpoints": "AHU- & PAU-Temperaturen und Sollwerte",
    "CHW DP vs OAT": "CHW-Druckdifferenz vs. Außentemperatur",
    "Second Floor Mean Air Temperature": "Durchschnittliche Lufttemperatur im 2. Stock",
    "First Floor Air Temperature": "Lufttemperatur im 1. Stock",
    "Reset": "Zurücksetzen",
    "Upload Point List": "Punkteliste hochladen",
    "Upload Point List CSV": "CSV-Punkteliste hochladen",
    "Point List upload": "Auffüllung der Sensorliste",
    "Upload data for": "Daten hochladen für",
    "Upload CSV data for": "CSV-Daten hochladen für",
    "Add Equipment": "Ausrüstung hinzufügen",
    "Add Point": "Messpunkt hinzufügen",
    "Edit Equipment": "Ausrüstung bearbeiten",
    "Delete Equipment": "Ausrüstung löschen",
    "Upload Data": "Daten hochladen",
    "Edit Point": "Messpunkt bearbeiten",
    "Delete Point": "Messpunkt löschen",
    "Algorithmic Fault Detection": "Algorithmische Fehlererkennung",
    "Automated Debug": "Automatisches Debugging",
    "Custom View Configuration Issues": "Probleme mit benutzerdefinierten Ansichts-Konfigurationen",
    "Chart Builder": "Diagrammgenerator",
    "Are you sure you want to delete this item?": "Sind Sie sicher, dass Sie dieses Element löschen möchten?",
    "Notes": "Notizen",
    "Sensor Name": "Sensorname",
    "Sensor Name Abbr": "Sensorname (Abk.)",
    "Faulty": "Fehlerhaft",
    "Upstream ID": "Upstream-ID",
    "Weight": "Gewichtung",
    "Are you sure you want to delete this sensor?": "Sind Sie sicher, dass Sie diesen Sensor löschen möchten?",
    "Are you sure you want to delete this equipment?": "Sind Sie sicher, dass Sie diese Ausrüstung löschen möchten?",
    "Add Query": "Abfrage hinzufügen",
    "Config ID": "Konfigurations-ID",
    "Config Name": "Konfigurationsname",
    "Facility Name": "Anlagenname",
    "Equipment Tags": "Ausrüstungs-Tags",
    "Equipment ID": "Ausrüstungs-ID",
    "Facility ID": "Anlagen-ID",
    "Description": "Beschreibung",
    "Sampling Frequency": "Abtastfrequenz",
    "Meta": "Metadaten",
    "ON": "Ein",
    "OFF": "Aus",
    "Unit": "Einheit",
    "yes": "ja",
    "Yes": "Ja",
    "no": "nein",
    "No": "Nein",
    "Query": "Abfrage",
    "data": "Daten",
    "On Only": "Nur bei Betrieb",
    "Date range offset": "Datumsbereich-Offset",
    "Add Time Aggregation": "Zeitaggregation hinzufügen",
    "Add Aggregation": "Aggregation hinzufügen",
    "Add Series Calculation": "Berechnung für Serien hinzufügen",
    "Add Dataframe Transformation": "Dataframe-Transformation hinzufügen",
    "Add Filter": "Filter hinzufügen",
    "Add Series Selection": "Serienauswahl hinzufügen",
    "Add Series Insertion": "Serien-Einfügung hinzufügen",
    "Range offset": "Bereichs-Offset",
    "Offset unit": "Offset-Einheit",
    "Offset amount": "Offset-Menge",
    "Disable Offset": "Offset deaktivieren",
    "Time Aggregation": "Zeitaggregation",
    "Frequency": "Frequenz",
    "Operation": "Operation",
    "Divide by sampling freq": "Durch Abtastfrequenz teilen",
    "Horizontal Aggregation": "Horizontale Aggregation",
    "Name": "Name",
    "Insert Series": "Serie einfügen",
    "Field": "Feld",
    "Value": "Wert",
    "Series Calculation": "Serienberechnung",
    "Remove Others": "Andere entfernen",
    "Formula": "Formel",
    "Dataframe Transformation": "Dataframe-Transformation",
    "Series Selection": "Serienauswahl",
    "Add Series": "Serie hinzufügen",
    "Please select a Sensor Name or an Equipment Name": "Bitte wählen Sie einen Sensor- oder Ausrüstungsnamen aus",
    "layout": "Layout",
    "Chart Type": "Diagrammtyp",
    "Trace Type": "Spurtyp",
    "Fill": "Füllung",
    "Fill color": "Füllfarbe",
    "Y Axis": "Y-Achse",
    "Stack Group": "Stack-Gruppe",
    "Render as Smooth Line": "Als glatte Linie darstellen",
    "Min": "Min",
    "Max": "Max",
    "Color": "Farbe",
    "Custom Unit": "Benutzerdefinierte Einheit",
    "Opacity": "Transparenz",
    "Indicator Mode": "Indikator-Modus",
    "Gauge Min": "Mindestwert der Skala",
    "Gauge Max": "Höchstwert der Skala",
    "Bar color": "Balkenfarbe",
    "Border color": "Rahmenfarbe",
    "Background color": "Hintergrundfarbe",
    "Bar Mode": "Balkenmodus",
    "Show Scale": "Skala anzeigen",
    "Custom Color Gradient": "Benutzerdefinierter Farbverlauf",
    "Donut": "Donut-Diagramm",
    "Box Points": "Boxplot-Punkte",
    "Horizontal": "Horizontal",
    "Xbins Size": "Größe der X-Bins",
    "Ybins Size": "Größe der Y-Bins",
    "Add step": "Schritt hinzufügen",
    "Gauge Steps": "Schritte der Messanzeige",
    "Title": "Titel",
    "Chart layout": "Diagrammlayout",
    "Height": "Höhe",
    "Top Margin": "Oberer Rand",
    "Left Margin": "Linker Rand",
    "Right Margin": "Rechter Rand",
    "Bottom Margin": "Unterer Rand",
    "Hover Tooltip Behaviour": "Verhalten des Tooltip beim Hover",
    "Show Legend": "Legende anzeigen",
    "Chart Colors": "Diagrammfarben",
    "Add Color": "Farbe hinzufügen",
    "Axis settings": "Achseneinstellungen",
    "X Axis Field": "X-Achsenfeld",
    "Independent X Series per Query": "Unabhängige X-Serie pro Abfrage",
    "X Axis Label": "Beschriftung der X-Achse",
    "X Axis Format": "Format der X-Achse",
    "Y Axis Label": "Beschriftung der Y-Achse",
    "Secondary Y Axis": "Zweite Y-Achse",
    "Secondary Y Axis Label": "Beschriftung der zweiten Y-Achse",
    "Color Axis Field": "Feld für Farbskala",
    "Color Axis Scale": "Skala der Farbskala",
    "Color Axis Label": "Beschriftung der Farbskala",
    "3D Mode Y Axis Field": "Y-Achsenfeld im 3D-Modus",
    "Close": "Schließen",
    "Compare X": "X vergleichen",
    "Closest to pointer": "Nächste zum Zeiger",
    "Primary": "Primär",
    "Secondary": "Sekundär",
    "hour": "Stunde",
    "day": "Tag",
    "week": "Woche",
    "month": "Monat",
    "year": "Jahr",
    "Sensor ID": "Sensor-ID",
    "Type": "Typ",
    "Connectors": "Anschlüsse",
    "Custom View Builder": "Benutzerdefinierter Ansichts-Generator",
    "Edit Custom View": "Benutzerdefinierte Ansicht bearbeiten",
    "Default Date Range": "Standard-Zeitbereich",
    "Link Title": "Link-Titel",
    "Column width": "Spaltenbreite",
    "Edit": "Bearbeiten",
    "Duplicate": "Duplizieren",
    "Delete": "Löschen",
    "Map": "Karte",
    "Pitch": "Neigung",
    "Zoom": "Zoom",
    "Center Latitude": "Zentrierter Breitengrad",
    "Center Longitude": "Zentrierter Längengrad",
    "Markers": "Markierungen",
    "Image URL": "Bild-URL",
    "Link URL": "Link-URL",
    "Latitude": "Breitengrad",
    "Longitude": "Längengrad",
    "Add Marker": "Marker hinzufügen",
    "OK": "OK",
    "Width": "Breite",
    "Radius": "Radius",
    "Blur": "Weichzeichnen",
    "Max opacity": "Maximale Deckkraft",
    "Player": "Player",
    "Agg Frequency": "Aggregationsfrequenz",
    "Agg Operation": "Aggregationsoperation",
    "Cutoff Date": "Cutoff-Datum",
    "Interpolation": "Interpolation",
    "Min X": "Min. X",
    "Max X": "Max. X",
    "Min Power": "Min. Leistung",
    "Max Power": "Max. Leistung",
    "Power Sensor": "Leistungssensor",
    "X Sensor": "X-Sensor",
    "X Title": "X-Achsentitel",
    "X Agg Operation": "X-Aggregationsoperation",
    "Switch Sensor": "Schaltersensor",
    "Use Switch": "Schalter verwenden",
    "Custom Interpolation Function": "Benutzerdefinierte Interpolationsfunktion",
    "Min Cooling Load": "Min. Kühllast",
    "Max Cooling Load": "Max. Kühllast",
    "COP Improvement": "COP-Verbesserung",
    "Cooling Load Sensor": "Kühllast-Sensor",
    "Use Filter": "Filter verwenden",
    "Filter Sensor": "Filter-Sensor",
    "Min Filter": "Min.-Filter",
    "Max Filter": "Max.-Filter",
    "Correlation": "Korrelation",
    "Relevant Variables": "Relevante Variablen",
    "Rule Active when Equipment On": "Regel aktiv, wenn Gerät eingeschaltet",
    "Rule Active when Equipment Off": "Regel aktiv, wenn Gerät ausgeschaltet",
    "Rule Active Anytime": "Regel immer aktiv",
    "Show Cost": "Kosten anzeigen",
    "X Axis Title": "Titel der X-Achse",
    "Y Axis Title": "Titel der Y-Achse",
    "Expected Value Line Name": "Name der Kurve für erwarteten Wert",
    "Fitted Value Line Name": "Name der Kurve für angepassten Wert",
    "Actual Observed Value Line Name": "Name der Kurve für tatsächlichen Wert",
    "Confidence Interval Name": "Name des Konfidenzintervalls",
    "Cooling Load Forecast": "Prognose der Kühllast",
    "Staging Profile": "Stufenprofil",
    "Heatmap": "Heatmap",
    "Fault Evaluation": "Fehlerauswertung",
    "Chiller Sequencing FLA": "Kältemaschine-Sequenzierung FLA",
    "Chiller Sequencing Delta": "Kältemaschine-Sequenzierung Delta",
    "Cooling Load vs OAT": "Kühllast vs. Außentemperatur",
    "Return to Custom Views": "Zu benutzerdefinierten Ansichten zurückkehren",
    "Add chart": "Diagramm hinzufügen",
    "Add Chart": "Diagramm hinzufügen",
    "Save as custom view": "Als benutzerdefinierte Ansicht speichern",
    "Add Custom Chart": "Benutzerdefiniertes Diagramm hinzufügen",
    "Pie": "Kreisdiagramm",
    "Bar": "Balkendiagramm",
    "Histogram": "Histogramm",
    "Stacked Area": "Gestapeltes Flächendiagramm",
    "Line": "Liniendiagramm",
    "Scatter": "Streudiagramm",
    "3D Scatter": "3D-Streudiagramm",
    "Scatter with Color Scale": "Streudiagramm mit Farbskala",
    "Optimization": "Optimierung",
    "View All": "Alle anzeigen",
    "Changes Saved": "Änderungen gespeichert",
    "Are you sure you want to delete this connector?": "Sind Sie sicher, dass Sie diesen Anschluss löschen möchten?",
    "New Simple View": "Neue einfache Ansicht",
    "New Advanced View": "Neue erweiterte Ansicht",
    "Import JSON": "JSON importieren",
    "Import Preset": "Voreinstellung importieren",
    "Import Local Plots": "Lokale Diagramme importieren",
    "Import custom view from JSON": "Benutzerdefinierte Ansicht aus JSON importieren",
    "Import": "Importieren",
    "Publish": "Veröffentlichen",
    "Un-Publish": "Veröffentlichung aufheben",
    "Export": "Exportieren",
    "Facility": "Anlage",
    "Published": "Veröffentlicht",
    "Top-level Link": "Link auf oberster Ebene",
    "Link position": "Linkposition",
    "Menu Folder": "Menüordner",
    "Are you sure you want to delete this view?": "Sind Sie sicher, dass Sie diese Ansicht löschen möchten?",
    "View Deleted": "Ansicht gelöscht",
    "Custom view saved": "Benutzerdefinierte Ansicht gespeichert",
    "Are you sure you want to upload all local plots to your user account?": "Sind Sie sicher, dass Sie alle lokalen Diagramme in Ihr Benutzerkonto hochladen möchten?",
    "Views Imported": "Ansichten importiert",
    "A custom view with this ID already exists. Are you sure you want to override it ?": "Eine benutzerdefinierte Ansicht mit dieser ID existiert bereits. Wollen Sie sie wirklich überschreiben?",
    "End date": "Enddatum",
    "Dynamic Control": "Dynamische Steuerung",
    "Software Switches": "Software-Schalter",
    "Control Readings": "Steuerungswerte",
    "Sensor Readings": "Sensorwerte",
    "Point Name": "Punktname",
    "Status": "Status",
    "Error": "Fehler",
    "Equipment plots": "Ausrüstungsdiagramme",
    "Equipment name": "Ausrüstungsname",
    "Start date": "Startdatum",
    "Floor name": "Etagenname",
    "Equipment Summary": "Ausrüstungsübersicht",
    "Display equipment plots": "Ausrüstungsdiagramme anzeigen",
    "Display anomalies": "Anomalien anzeigen",
    "Data Export": "Datenexport",
    "View Data": "Daten anzeigen",
    "Download CSV": "CSV herunterladen",
    "Time Agg Frequency": "Zeit-Aggregationsfrequenz",
    "Time Agg Operation": "Zeit-Aggregationsoperation",
    "Return data as": "Daten zurückgeben als",
    "Series name": "Serienname",
    "Change Password": "Passwort ändern",
    "Your password has not been changed in over 3 months. Please consider updating it for security.": "Ihr Passwort wurde seit über 3 Monaten nicht geändert. Bitte erwägen Sie, es aus Sicherheitsgründen zu aktualisieren.",
    "User ID": "Benutzer-ID",
    "Update On": "Aktualisiert am",
    "Created On": "Erstellt am",
    "Role": "Rolle",
    "Users": "Benutzer",
    "Dashboard Setup": "Dashboard-Einrichtung",
    "Not logged in as administrator": "Nicht als Administrator angemeldet",
    "Log Out": "Abmelden",
    "Dashboard setup complete": "Dashboard-Einrichtung abgeschlossen",
    "Back to Home": "Zurück zur Startseite",
    "Current Logged In User": "Aktuell angemeldeter Benutzer",
    "Facility and Points": "Anlage und Messpunkte",
    "Current Facility": "Aktuelle Anlage",
    "Equipment List and Points": "Ausrüstungsliste und Punkte",
    "used": "verwendet",
    "licensed": "lizenziert",
    "Setting": "Einstellung",
    "sample": "Beispiel",
    "samples": "Beispiele",
    "every hour": "stündlich",
    "Currency and Energy Pricing": "Währung und Energiebepreisung",
    "per kWh": "pro kWh",
    "Points List": "Punkteliste",
    "Energy Price": "Energiepreis",
    "Equipment On": "Ausrüstung Ein",
    "Equipment Off": "Ausrüstung Aus",
    "Anytime": "Jederzeit",
    "Active": "Aktiv",
    "Inactive": "Inaktiv",
    "Muted": "Stummgeschaltet",
    "Muted by": "Stummgeschaltet von",
    "Muted date": "Stummschaltungsdatum",
    "Mute": "Stummschalten",
    "Un-Mute": "Stummschaltung aufheben",
    "Applicable Group(s)": "Zugehörige Gruppe(n)",
    "Rule Active when": "Regel aktiv, wenn",
    "Active Status": "Aktivstatus",
    "Reports": "Berichte",
    "Test Message": "Testnachricht",
    "Severity Level(s)": "Schweregradstufe(n)",
    "Distribution List": "Verteilerliste",
    "Power Prediction": "Leistungsprognose",
    "Parameter Name": "Parametername",
    "Parameter Value": "Parameterwert",
    "Parameter Value Str": "Parameterwert (Text)",
    "Parameter Description": "Parameterbeschreibung",
    "Graphical View": "Grafische Ansicht",
    "Model": "Modell",
    "Add Model": "Modell hinzufügen",
    "Model Name": "Modellname",
    "Model Type": "Modelltyp",
    "Job": "Aufgabe",
    "Add Job": "Aufgabe hinzufügen",
    "New Job": "Neue Aufgabe",
    "No Result Yet": "Noch kein Ergebnis",
    "Reset all result": "Alle Ergebnisse zurücksetzen",
    "Reset all result will delete all result and rerun with latest setting.": "Durch das Zurücksetzen aller Ergebnisse werden alle gelöscht und mit den neuesten Einstellungen neu ausgeführt.",
    "Train Comp Power Model": "Comp-Power-Modell trainieren",
    "This will retrain the Comp Power Model": "Dadurch wird das Comp-Power-Modell neu trainiert",
    "Ack Old Notifications": "Alte Benachrichtigungen bestätigen",
    "Ack Old Notifications older than the following threshold or 30 days if no threshold is mentioned.":
        "Bestätigt alte Benachrichtigungen, die älter sind als der folgende Grenzwert oder 30 Tage, wenn kein Grenzwert erwähnt wird.",
    "End date threshold": "Grenzwert für Enddatum",
    "Job ID": "Aufgaben-ID",
    "Carnot Innovations Terms of Service": "Nutzungsbedingungen von Carnot Innovations",
    "Critical": "Kritisch",
    "Download with Maintenance": "Herunterladen (inkl. Wartung)",
    "Severity filter": "Schweregradfilter",
    "Notification ID": "Benachrichtigungs-ID",
    "Occurred Times": "Anzahl der Vorkommnisse",
    "Focus Range": "Fokusbereich",
    "Location": "Standort",
    "Start Time": "Startzeit",
    "End Time": "Endzeit",
    "Comments": "Kommentare",
    "Actions Taken": "Ergriffene Maßnahmen",
    "Reported by": "Gemeldet von",
    "Report date": "Datum der Meldung",
    "Certified by": "Zertifiziert durch",
    "Certified date": "Zertifizierungsdatum",
    "Endorsed by": "Abgesegnet durch",
    "Endorsed date": "Bestätigungsdatum",
    "Menu List": "Menüliste",
    "New Folder Name": "Neuer Ordnername",
    "Available Views": "Verfügbare Ansichten",
    "Edit Folder Name": "Ordnername bearbeiten",
    "Edit Custom View Display": "Benutzerdefinierte Ansichtsdarstellung bearbeiten",
    "Custom View Name": "Name der benutzerdefinierten Ansicht",
    "Icon": "Symbol",
    "Folder cannot be nested!": "Ordner kann nicht verschachtelt werden!",
    "Folder name must be unique.": "Der Ordnername muss eindeutig sein.",
    "Add Anomaly Description": "Anomaliebeschreibung hinzufügen",
    "Relevant variable": "Relevante Variable",
    "Equipment Regex": "Geräte-Regex",
    "Time Delay": "Zeitverzögerung",
    "Open diagnostics view": "Diagnoseansicht öffnen",
    "timestamp": "Zeitstempel",
    "Top 10 overall anomaly scores": "Top 10 der Gesamtanomalie-Werte",
    "File must be selected.": "Eine Datei muss ausgewählt sein.",
    "Exactly 1 file must be provided.": "Genau 1 Datei muss bereitgestellt werden.",
    "Done": "Fertig",
    "Please select 1 file to upload.": "Bitte 1 Datei zum Hochladen auswählen.",
    "Please wait ... It will take up to a minute.": "Bitte warten ... Es kann bis zu einer Minute dauern.",
    "Upload Completed.": "Upload abgeschlossen.",
    "Fail.  Please Retry.": "Fehlgeschlagen. Bitte erneut versuchen.",
    "Add Tag": "Tag hinzufügen",
    "Connector": "Connector",
    "Add Points": "Messpunkte hinzufügen",
    "Point Selector": "Punktselektor",
    "Available points": "Verfügbare Punkte",
    "Show filters": "Filter anzeigen",
    "Hide filters": "Filter verbergen",
    "Selected points": "Ausgewählte Punkte",
    "Clear selection": "Auswahl aufheben",
    "Add selected points": "Ausgewählte Punkte hinzufügen",
    "Total energy consumption (kWh)": "Gesamtenergieverbrauch (kWh)",
    "Energy Savings": "Energieeinsparungen",
    "Add Dates": "Daten hinzufügen",
    "Add Equipment Servicing Schedule": "Geräte-Wartungsplan hinzufügen",
    "Applies to": "Gilt für",
    "Entire Site": "Gesamte Anlage",
    "Floor Name": "Etagenname",
    "View": "Ansicht",
    "Apply changes": "Änderungen anwenden",
    "Save whiteboard": "Whiteboard speichern",
    "Edit all notes": "Alle Notizen bearbeiten",
    "Add Stickie to board": "Haftnotiz zum Whiteboard hinzufügen",
    "Add Photo / Graphics to board": "Foto/Grafik zum Whiteboard hinzufügen",
    "Add Board": "Whiteboard hinzufügen",
    "Board Name": "Whiteboard-Name",
    "Double Click to select an image.": "Doppelklicken, um ein Bild auszuwählen.",
    "Edit this Stickie": "Diese Haftnotiz bearbeiten",
    "Delete this Stickie": "Diese Haftnotiz löschen",
    "Edit Image": "Bild bearbeiten",
    "Edit Label": "Beschriftung bearbeiten",
    "Label": "Beschriftung",
    "Label Only": "Nur Beschriftung",
    "Font size": "Schriftgröße",
    "Font color": "Schriftfarbe",
    "Variable": "Variable",
    "Microsoft authentication anomaly. Please renew login.": "Microsoft-Authentifizierungsanomalie. Bitte Anmeldung erneuern.",
    "Change Backend URL": "Backend-URL ändern",
    "Target URL": "Ziel-URL",
    "Setting URL.  Please wait.": "URL wird eingestellt. Bitte warten.",
    "Set": "Festlegen",
    "Model ID": "Modell-ID",
    "Target Equipment": "Zielausrüstung",
    "Model Selection": "Modellauswahl",
    "Model Message": "Modellnachricht",
    "Training Data Date Range": "Datumsbereich für Trainingsdaten",
    "Severity Levels": "Schweregrade",
    "Phone number": "Telefonnummer",
    "Message": "Nachricht",
    "Send": "Senden",
    "Active - rule will be applied": "Aktiv – Regel wird angewendet",
    "Inactive - rule will not run": "Inaktiv – Regel wird nicht ausgeführt",
    "Muted - rules will be applied, but notifications (if any) will immediately be acknowledged":
        "Stummgeschaltet – Regeln werden angewendet, aber Benachrichtigungen (falls vorhanden) sofort bestätigt",
    "Used parameters": "Verwendete Parameter",
    "Recommended Action": "Empfohlene Aktion",
    "Run test": "Test ausführen",
    "Test the rule": "Regel testen",
    "Validation succeeded!": "Validierung erfolgreich!",
    "Password not matched / Password cannot be empty": "Passwörter stimmen nicht überein / Passwort darf nicht leer sein",
    "Password is too common. Please choose a more unique password.": "Das Passwort ist zu häufig verwendet. Bitte wählen Sie ein eindeutigeres Passwort.",
    "Password should not contain personal information or username.": "Das Passwort sollte keine persönlichen Informationen oder den Benutzernamen enthalten.",
    "Password should not contain common dictionary words.": "Das Passwort sollte keine häufigen Wörterbuch-Wörter enthalten.",
    "Password should not contain sequential characters (e.g., 1234, abcd).": "Das Passwort sollte keine aufeinanderfolgenden Zeichen enthalten (z.B. 1234, abcd).",
    "Password does not meet minimum complexity requirements.": "Das Passwort erfüllt nicht die Mindestanforderungen für Komplexität.",
    "Password does not meet security requirements.": "Das Passwort erfüllt nicht die Sicherheitsanforderungen.",
    "Password must be unique, complex, and avoid common words or personal information. Avoid easily guessed passwords like \"Password1234\" or \"Las Vegas\".": "Das Passwort muss eindeutig und komplex sein und häufige Wörter oder persönliche Informationen vermeiden. Vermeiden Sie leicht zu erratende Passwörter wie \"Password1234\" oder \"Las Vegas\".",
    "Confirm New Password": "Neues Passwort bestätigen",
    "New Password": "Neues Passwort",
    "uppercase letters": "Großbuchstaben",
    "lowercase letters": "Kleinbuchstaben",
    "numbers": "Zahlen",
    "special characters": "Sonderzeichen",
    "unicode characters": "Unicode-Zeichen",
    "Password must contain at least 4 different character types (uppercase, lowercase, numbers, special characters, unicode)": "Das Passwort muss mindestens 4 verschiedene Zeichentypen enthalten (Großbuchstaben, Kleinbuchstaben, Zahlen, Sonderzeichen, Unicode-Zeichen)",
    "Administrator": "Administrator",
    "Maintainer": "Wartungspersonal",
    "Operator": "Bediener",
    "Updated On": "Aktualisiert am",
    "Authorized Facilities": "Autorisierte Anlagen",
    "User Account": "Benutzerkonto",
    "Monthly Summary Energy/Faults": "Monatliche Zusammenfassung Energie/Fehler",
    "Monthly Summary: Chiller Plant": "Monatliche Zusammenfassung: Kältemaschinenanlage",
    "Chiller Staging": "Kältemaschine-Stufenbetrieb",
    "Edit Maintenance Record": "Wartungsprotokoll bearbeiten",
    "Builder": "Ersteller",
    "Equipment Group": "Ausrüstungsgruppe",
    "FDD Breakdown": "FDD-Aufschlüsselung",
    "Cluster View": "Cluster-Ansicht",
    "Get link": "Link abrufen",
    "Chiller Plant Overview": "Übersicht Kältemaschinenanlage",
    "General - CHW_Header Leaving and Entering Temp": "Allgemein – Austritts- und Eintrittstemperatur des CHW-Sammlers",
    "General - CHW_Header DP vs OAT": "Allgemein – CHW-Sammler-DP vs. Außentemperatur",
    "Advanced - Cooling Load and Power Over Time": "Erweitert – Kühllast und Leistung über die Zeit",
    "Advanced - CHW_Header Depth Analysis": "Erweitert – Tiefenanalyse des CHW-Sammlers",
    "Cooling Load Prediction": "Vorhersage der Kühllast",
    "Last 10 Days Cooling Load Prediction": "Vorhersage der Kühllast für die letzten 10 Tage",
    "Hide Date": "Datum ausblenden",
    "Monthly": "Monatlich",
    "Month Range": "Monatsbereich",
    "On Only Switch": "Nur wenn Schalter auf Ein",
    "Equip Select": "Geräteauswahl",
    "Equipment Type filter": "Filter für Ausrüstungstyp",
    "Equipment Floor filter": "Filter für Ausrüstungsetage",
    "Min Width": "Min. Breite",
    "Borders": "Rahmen",
    "Restricted Access": "Eingeschränkter Zugriff",
    "Namespace": "Namensraum",
    "Hide Controls": "Steuerungselemente ausblenden",
    "Menu Config": "Menükonfiguration",
    "Save As": "Speichern unter",
    "Add Component": "Komponente hinzufügen",
    "Rich Text": "Rich Text",
    "Notification Facet": "Benachrichtigungsfacette",
    "3D Viewer": "3D-Viewer",
    "3D Heatmap": "3D-Heatmap",
    "Custom Optimization": "Benutzerdefinierte Optimierung",
    "Custom COP Savings": "Benutzerdefinierte COP-Einsparungen",
    "Custom": "Benutzerdefiniert",
    "HTML Code": "HTML-Code",
    "Custom EC": "Benutzerdefiniertes EC",
    "Animation": "Animation",
    "Enable Merge": "Zusammenführen aktivieren",
    "Animation timer (seconds)": "Animationsdauer (Sekunden)",
    "Maintenance Summary": "Wartungszusammenfassung",
    "Issue Summary": "Problemübersicht",
    "Grahic": "Grafik",
    "FDD Report": "FDD-Bericht",
    "Cost Breakdown": "Kostenaufschlüsselung",
    "Sensor Cailbration": "Sensor-Kalibrierung",
    "Energy Breakdown": "Energieaufschlüsselung",
    "Solar": "Solar",
    "Main light intensity": "Hauptlichtintensität",
    "Ambient light intensity": "Umgebungslichtintensität",
    "Show Clock": "Uhr anzeigen",
    "Parameters": "Parameter",
    "Autotuner": "Auto-Tuner",
    "Actual Observed Value": "Tatsächlich beobachteter Wert",
    "Fitted Value": "Angepasster Wert",
    "Expected Value": "Erwarteter Wert",
    "Insert at": "Einfügen bei",
    "Air-side": "Luftseite",
    "Air-side Overview": "Übersicht (Luftseite)",
    "Air-side CO2 Overtime": "CO₂ (Luftseite) im Zeitverlauf",
    "AHU Temp and VFD Over Time": "AHU-Temperatur und VFD im Zeitverlauf",
    "Download plot as a png": "Diagramm als PNG herunterladen",
    "Zoom in": "Vergrößern",
    "Zoom out": "Verkleinern",
    "Autoscale": "Automatische Skalierung",
    "Reset axes": "Achsen zurücksetzen",
    "Pan": "Verschieben",
    "Toggle Spike Lines": "Spike-Linien umschalten",
    "Show closest data on hover": "Nächste Daten beim Hover anzeigen",
    "Compare data on hover": "Daten beim Hover vergleichen",
    "Produced with Plotly": "Erstellt mit Plotly",
    "Rows per page": "Zeilen pro Seite",
    "Maintenance ID": "Wartungs-ID",
    "View points when equipment is On": "Punkte anzeigen, wenn Ausrüstung eingeschaltet ist",
    "Reassign user for all maintenance records": "Benutzer für alle Wartungsprotokolle neu zuweisen",
    "Mass Reassign": "Massen-Neuzuweisung",
    "Currently assigned to": "Derzeit zugewiesen an",
    "Reassign to": "Neu zuweisen an",
    "Reassign": "Neu zuweisen",
    "View Diff": "Differenz anzeigen",
    "Diff mode": "Differenzmodus",
    "Select file": "Datei auswählen",
    "Choose File": "Datei wählen",
    "Convert categorical to numeric": "Kategorisch in numerisch konvertieren",
    "Resampling": "Resampling",
    "Matching": "Zuordnung",
    "Data Upload": "Daten-Upload",
    "Toggle Connectors": "Anschlüsse umschalten",
    "Graphic": "Grafik",
    "Equipment Relationships": "Beziehungen zwischen Ausrüstungen",
    "Equipment1": "Ausrüstung1",
    "Equipment2": "Ausrüstung2",
    "Graph view": "Grafische Ansicht",
    "List view": "Listenansicht",
    "Relationships type": "Beziehungstyp",
    "Equipment Relationships Upload": "Upload von Ausrüstungsbeziehungen",
    "Point Mapping": "Punktzuordnung",
    "Point Mapper": "Punktzuordner",
    "Mass Update": "Massenaktualisierung",
    "Split Paths": "Pfad aufteilen",
    "Map Points": "Punkte zuordnen",
    "Get Suggestions": "Vorschläge abrufen",
    "Suggestions": "Vorschläge",
    "Units": "Einheiten",
    "Delete Table": "Tabelle löschen",
    "id": "ID",
    "path": "Pfad",
    "carnot_name": "Carnot-Name",
    "point": "Messpunkt",
    "equip": "Ausrüstung",
    "equip_type": "Ausrüstungstyp",
    "floor": "Etage",
    "tower": "",
    "unit": "Einheit",
    "actions": "Aktionen",
    "No data available": "Keine Daten verfügbar",
    "Discovered Points": "Entdeckte Punkte",
    "upstream_id": "Upstream-ID",
    "upstream_sensor_name": "Upstream-Sensorname",
    "site": "Standort",
    "sensor_name": "Sensorname",
    "sensor_desc": "Sensorbeschreibung",
    "meta": "Metadaten",
    "equip_meta": "Ausrüstungs-Metadaten",
    "Unmapped Only": "Nur nicht zugeordnete",
    "Scripts": "Skripte",
    "Script": "Skript",
    "Version": "Version",
    "Updated": "Aktualisiert",
    "Optimization Controls": "Optimierungssteuerung",
    "Current Value": "Aktueller Wert",
    "Write": "Schreiben",
    "Priority": "Priorität",
    "Graphics": "Grafiken",
    "Dashboard": "Dashboard",
    "Build time": "Erstellungszeit",
    "Coordinated Universal Time": "Koordinierte Weltzeit (UTC)",
    "Rule Creation": "Regelerstellung",
    "Auto-diagnose": "Auto-Diagnose",
    "This will disable all rules which lack the required variables. Are you sure you want to run auto-diagnostic?":
        "Dies deaktiviert alle Regeln, denen die erforderlichen Variablen fehlen. Möchten Sie wirklich die Auto-Diagnose ausführen?",
    "KPI Thresholds": "KPI-Grenzwerte",
    "Custom view": "Benutzerdefinierte Ansicht",
    "New Link Name": "Neuer Linkname",
    "Show Recent Notifications Only": "Nur aktuelle Benachrichtigungen anzeigen",
    "Apply": "Anwenden",
    "3D Model link": "3D-Modell-Link",
    "Close testing interface": "Testoberfläche schließen",
    "Component Titles": "Komponententitel",
    "Last Updated": "Zuletzt aktualisiert",
    "Add components": "Komponenten hinzufügen",
    "Toggle sensor picker": "Sensorauswahl umschalten",
    "Toggle debug mode": "Debugmodus umschalten",
    "Time aggregation": "Zeitaggregation",
    "Latest Only": "Nur Aktuelle",
    "Custom date range": "Benutzerdefinierter Datumsbereich",
    "Presents": "Präsentationen",
    "Summary": "Zusammenfassung",
    "Bar - group": "Balken – Gruppe",
    "Bar - stack": "Balken – Stapel",
    "Bar summary": "Balkenzusammenfassung",
    "Gauge": "Messanzeige",
    "Number": "Zahl",
    "Layout": "Layout",
    "Legend Position": "Legendenposition",
    "Colors": "Farben",
    "Limit X Axis Ticks": "Anzahl der X-Achsen-Ticks begrenzen",
    "Y Axis Format": "Format der Y-Achse",
    "Y Axis Custom Range": "Benutzerdefinierter Bereich der Y-Achse",
    "Marker Size Field": "Feld für Markierungsgröße",
    "Color Axis Custom Range": "Benutzerdefinierter Bereich der Farbskala",
    "Annotations": "Anmerkungen",
    "Text": "Text",
    "Returned series": "Zurückgegebene Serien",
    "Add Series Insertion by Ref": "Serien-Einfügung per Referenz hinzufügen",
    "Add Calendar Insertion": "Kalendereinfügung hinzufügen",
    "Add Conversion to enum": "Konvertierung in enum hinzufügen",
    "Number Size": "Zahlengröße",
    "Number Format": "Zahlenformat",
    "Create a writable connector to add writable points": "Erstellen Sie einen schreibbaren Connector, um schreibbare Punkte hinzuzufügen",
    "Generate API Token": "API-Token generieren",
    "Username": "Benutzername",
    "Two Factor Code": "Zwei-Faktor-Code",
    "Your API token has been generated. Copy and store it securely:": "Ihr API-Token wurde generiert. Kopieren und sicher aufbewahren:",
    "API Token": "API-Token",
    "This token has a long expiration and can be used for API authentication. Keep it secure and do not share it.": "Dieser Token hat eine lange Gültigkeitsdauer und kann für die API-Authentifizierung verwendet werden. Bewahren Sie ihn sicher auf und teilen Sie ihn nicht.",
    "Generate Token": "Token generieren",
    "Token copied to clipboard": "Token in die Zwischenablage kopiert",
    " assigned this to ": " hat dies zugewiesen an ",
    " fixed this": " hat dies behoben",
    " matching notifications?": " passende Benachrichtigungen?",
    " required fixing": " benötigte eine Behebung",
    "Adjustment Frequency": "Anpassungsfrequenz",
    "An error occurred while generating the token.": "Beim Generieren des Tokens ist ein Fehler aufgetreten.",
    "Are you sure you want mark ": "Sind Sie sicher, dass Sie markieren möchten ",
    "Are you sure you want to ack all ": "Sind Sie sicher, dass Sie alle bestätigen möchten ",
    "Are you sure you want to delete this equipment?. The deletion process is asynchronous. You can use the dashboard as usual while it runs in the background.": "Sind Sie sicher, dass Sie diese Ausrüstung löschen möchten? Der Löschvorgang ist asynchron. Sie können das Dashboard wie gewohnt verwenden, während er im Hintergrund läuft.",
    "Are you sure you want to delete this model?": "Sind Sie sicher, dass Sie dieses Modell löschen möchten?",
    "Are you sure you want to recalculate data for this calculated point?": "Sind Sie sicher, dass Sie die Daten für diesen berechneten Punkt neu berechnen möchten?",
    "Are you sure you want to reset the authenticator for this user?": "Sind Sie sicher, dass Sie den Authenticator für diesen Benutzer zurücksetzen möchten?",
    "Are you sure you want to retrain this model?": "Sind Sie sicher, dass Sie dieses Modell neu trainieren möchten?",
    "Are you sure you want to unack all ": "Sind Sie sicher, dass Sie alle Bestätigungen aufheben möchten ",
    "Async job requested": "Asynchroner Job angefordert",
    "Calculation Statement": "Berechnungsanweisung",
    "Changes saved": "Änderungen gespeichert",
    "Compare Y": "Y vergleichen",
    "Component coped to clipboard": "Komponente in die Zwischenablage kopiert",
    "Component copied to clipboard": "Komponente in die Zwischenablage kopiert",
    "Counts": "Zählungen",
    "custom month": "benutzerdefinierter Monat",
    "Custom view copied to clipboard": "Benutzerdefinierte Ansicht in die Zwischenablage kopiert",
    "Custom view too big. Size cannot exceed 5MB.": "Benutzerdefinierte Ansicht zu groß. Größe darf 5 MB nicht überschreiten.",
    "Data copied to clipboard": "Daten in die Zwischenablage kopiert",
    "data preview": "Datenvorschau",
    "Data uploaded": "Daten hochgeladen",
    "Date": "Datum",
    "Discovery requested": "Erkundung angefordert",
    "Discovery Requested": "Erkundung angefordert",
    "Done. Equipment relationships created: ": "Fertig. Gerätebeziehungen erstellt: ",
    "Done. Points created: ": "Fertig. Punkte erstellt: ",
    "Done. Recalculation jobs created: ": "Fertig. Neuberechnungsaufträge erstellt: ",
    "Equipment 1": "Gerät 1",
    "Equipment 2": "Gerät 2",
    "Event saved": "Ereignis gespeichert",
    "Extra Sensors": "Zusätzliche Sensoren",
    "Flatline": "Flatlinie",
    "Full query copied to clipboard": "Vollständige Abfrage in die Zwischenablage kopiert",
    "History re-import job requested": "Verlaufsneuimportauftrag angefordert",
    "Import complete": "Import abgeschlossen",
    "Invalid view JSON.": "Ungültige Ansichts-JSON.",
    "Issues": "Probleme",
    "Last 7 Days": "Letzte 7 Tage",
    "License maintenance is out of date.": "Lizenzwartung ist veraltet.",
    "License point limit exceeded. Data collection stopped.": "Lizenzpunktlimit überschritten. Datenerfassung gestoppt.",
    "Login failed. Please check your credentials.": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.",
    "Maintenance": "Wartung",
    "Maintenance records": "Wartungsaufzeichnungen",
    "Mapping config copied to clipboard": "Zuordnungskonfiguration in die Zwischenablage kopiert",
    "Missing Critical Sensors": "Fehlende kritische Sensoren",
    "Missing Important Sensors": "Fehlende wichtige Sensoren",
    "Missing Optional Sensors": "Fehlende optionale Sensoren",
    "Missing Sensors": "Fehlende Sensoren",
    "month end": "Monatsende",
    "month start": "Monatsbeginn",
    "Name must be unique.": "Name muss eindeutig sein.",
    "No calculated points found for this name": "Keine berechneten Punkte für diesen Namen gefunden",
    "No missing sensors detected": "Keine fehlenden Sensoren erkannt",
    "Note on": "Hinweis zu",
    "Occurrences": "Vorkommen",
    "Out of range Counts": "Außerhalb des Bereichs liegende Zählungen",
    "Owner": "Eigentümer",
    "Password cannot be empty": "Passwort darf nicht leer sein",
    "Password must be a valid string": "Passwort muss eine gültige Zeichenkette sein",
    "Password must be at least ": "Passwort muss mindestens ",
    "Password must be unique, complex, and avoid common words or personal information. Avoid easily guessed passwords like ": "Das Passwort muss eindeutig und komplex sein und gängige Wörter oder persönliche Informationen vermeiden. Vermeiden Sie leicht zu erratende Passwörter wie ",
    "Password must contain at least ": "Passwort muss mindestens enthalten ",
    "Password not matched": "Passwort stimmt nicht überein",
    "Please select an equipment": "Bitte wählen Sie ein Gerät aus",
    "Points already exists for: ": "Punkte existieren bereits für: ",
    "Points could not be created for: ": "Punkte konnten nicht erstellt werden für: ",
    "Points edited: ": "Punkte bearbeitet: ",
    "Progress": "Fortschritt",
    "Query item copied to clipboard": "Abfrageelement in die Zwischenablage kopiert",
    "Reassigned ": "Neu zugewiesen ",
    "Recalculation job requested": "Neuberechnungsauftrag angefordert",
    "Recommended Actions:": "Empfohlene Aktionen:",
    "Requested point mapping vendor not found": "Angeforderter Punktzuordnungsanbieter nicht gefunden",
    "Site": "Standort",
    "Sync complete": "Synchronisierung abgeschlossen",
    "Target": "Ziel",
    "Thank you for your feedback!": "Vielen Dank für Ihr Feedback!",
    "This will apply the chart preset and override any custom code. Are you sure you want to proceed?": "Dies wendet die Diagrammvoreinstellung an und überschreibt benutzerdefinierten Code. Sind Sie sicher, dass Sie fortfahren möchten?",
    "to sampling freq": "zur Abtastfrequenz",
    "Two-factor authentication required": "Zwei-Faktor-Authentifizierung erforderlich",
    "Update request sent": "Aktualisierungsanforderung gesendet",
    "View Exported": "Ansicht exportiert",
    "Viewer": "Betrachter",
    "year end": "Jahresende",
    "year start": "Jahresbeginn"
}